import { render, staticRenderFns } from "./review-package.vue?vue&type=template&id=03262332"
import script from "./review-package.vue?vue&type=script&lang=js"
export * from "./review-package.vue?vue&type=script&lang=js"
import style0 from "./review-package.vue?vue&type=style&index=0&id=03262332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports